const API_URL =
  process.env.NODE_ENV === 'development'
    ? '/api/walllabs_create'
    : 'https://pt8lbf5drh.execute-api.us-east-1.amazonaws.com/dev/walllabs_create'

const X_API_KEY = (
  process.env.VUE_APP_WALLLABS_API_KEY ||
  'p4DCTzH6tm2ctNyS0VE344fenvBDJfCq7GDaj6lC'
).trim()

export const S3_WALLPAPER_BASE =
  'https://walllabs-bucket.s3.amazonaws.com/wallpaper/'

function getHeaders() {
  return {
    'Content-Type': 'application/json',
    ...(process.env.NODE_ENV === 'development'
      ? {}
      : { 'X-Api-Key': X_API_KEY })
  }
}

export async function wallLabsRequest(body) {
  const response = await fetch(API_URL, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(body)
  })

  let data = {}
  try {
    data = await response.json()
  } catch {
    data = {}
  }

  if (!response.ok) {
    throw new Error(
      data?.Message || data?.message || `API Error: ${response.status}`
    )
  }

  if (data?.Status && String(data.Status).toUpperCase() !== 'SUCCESS') {
    throw new Error(data?.Message || data?.message || 'Request failed')
  }

  return data
}

export function listWallpapers() {
  return wallLabsRequest({ command: 'listWallpapers' })
}

export function addWallpaper({ wallpaper_name, category, s3_url }) {
  return wallLabsRequest({
    command: 'addWallpaper',
    wallpaper_name: String(wallpaper_name || '').trim(),
    category: String(category || '').trim(),
    s3_url: String(s3_url || '').trim()
  })
}

export function buildDefaultS3Url(wallpaperName, fileName = '') {
  const title = String(wallpaperName || '').trim() || 'wallpaper'
  const extension =
    String(fileName).match(/\.(png|jpe?g|webp)$/i)?.[1]?.toLowerCase() || 'png'
  return `${S3_WALLPAPER_BASE}${title}.${extension}`
}
